var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-empty',{staticClass:"custom-image",attrs:{"image":require('@/assets/images/squirrelCup/2024/cupTwo/empty.png'),"description":_vm.word}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }